import styled from "styled-components/macro";
import { DropdownItem } from "reactstrap";
import { Flex } from "../../../../components/Common.Styled";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const COLOR_BLUE = "#004cff";
export const COLOR_BLUE_LIGHT = "#F5FAFE";
export const COLOR_ORANGE = "#FC4500";
export const COLOR_ORANGE_LIGHT = "#FC450049";

export const SHADOW = "0 0 10px -3px #0007";

export const NA = styled.span`
  color: #aaa;
  font-size: 0.8em;
`;

export const HomeDataCont = styled.div`
  margin: 100px 0;
  @media (max-width: 769px) {
    margin: 40px 0;
  }
  /* background-color: green; */
`;

export const Head = styled((props) => <Flex jc="sb" {...props} />)``;

export const HeadLeft = styled.div`
  max-width: 500px;
`;

export const HeadRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeadTitle = styled.h2``;

export const HeadDesc = styled.p`
  font-size: 0.8em;
`;

export const BrowseMoreBtn = styled.button`
  /* padding: 0.5em 0em; */
  border-radius: 10px;
  border: 1px solid lightgray;
  /* width: 6rem; */
  font-weight: 500;
  /* &:hover,
  &:focus {
    background: #15396dee;
  } */
`;
export const ShrBtnRw = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* padding-left: ${defaultLanguage === "ar" ? "0" : "10px"}; */
  /* padding-right: ${defaultLanguage === "ar" ? "10px" : "0"}; */
`;
export const ShrText = styled.div`
  width: 60%;
  font-size: 1.1rem;
  margin-right: ${defaultLanguage === "ar" ? "0" : "0rem"};
  margin-left: ${defaultLanguage === "ar" ? "0" : ""};
  padding: 0.2rem 0.3rem 0.2rem 0.6rem;
`;
export const ShrImgBx = styled.div`
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${defaultLanguage === "ar" ? "rotate(180deg)" : ""};
`;
export const ShrImg = styled.img`
  width: 45px;
  object-fit: cover;
`;

export const FilterBtn = styled.button`
  padding: 0.5em 0em;
  border-radius: 0.25em;
  border: 1px solid #ed7d2b;
  width: 6rem;
  font-weight: 500;

  /* &: hover;
  &:focus {
    background: #15396dee;
  } */
`;

export const ShareBtn = styled.button`
  padding: 0.75em 1em;
  border-radius: 0.25em;
  background-color: #15396d;
  color: #fff;
  margin-top: 0.5rem;

  &:hover,
  &:focus {
    background: #15396dee;
  }
`;

export const Body = styled.div`
  margin: 3em 0rem;
`;

export const ProfileMenuWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem 1rem;
  background: #f5fafe 0% 0% no-repeat padding-box;
  border-radius: 8px;
  box-shadow: 0px 4px 32px #00000014;
`;

export const DdItem = styled(DropdownItem)`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 4px 32px #00000014;
  &:hover,
  &:focus {
    background: transparent;
    color: black;

    ${ProfileMenuWrap} {
      background: #15396d1f;
    }
  }
`;

export const DisplayText = styled.div`
  @media (max-width: 426px) {
    display: none;
  }
`;

export const DropMenuBox = styled.div`
  width: 100%;
  display: flex;
  /* margin: 0.4rem; */
  padding: 0.4rem;
  font-size: 1rem;
  justify-content: ${defaultLanguage === "ar" ? "right" : "left"};
  align-items: center;
`;
export const MenuTitle = styled.span`
  margin-right: ${defaultLanguage === "ar" ? "1rem" : "0"};
`;

const CompPrimDetsShareBtn = (props) => <Button background={COLOR_BLUE} color="#fff" rounded {...props} />;
export const PrimDetsShareBtn = styled(CompPrimDetsShareBtn)`
  width: 7em;
  @media (max-width: 426px) {
    width: 3.1rem;
    border-radius: 50%;
    padding: 1rem 0;
  }
`;

export const Button = styled.button`
  padding: 0.5em 1em;
  background-color: ${(props) => props.background || "#fff"};
  border-radius: ${(props) => (props.rounded ? "2em" : ".25em")};
  box-shadow: ${(props) => (props.shadowed ? SHADOW : "none")};
  color: ${(props) => props.color || COLOR_BLUE};
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus {
    opacity: 0.8;
    box-shadow: ${SHADOW}, inset 0 0 0 1px ${COLOR_BLUE};
  }
`;

export const IconS = styled.img`
  margin-right: 1rem;
  width: 20%;
`;

export const PropertyHeadWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
`;

export const ExploreText = styled.div`
width: 100%;
letter-spacing: 0px;
color: #ED7D2B;
opacity: 1;
font-size: 1.5rem;
font-weight: 500;
text-align: center;
@media (max-width: 520px) {
  font-size: 1.3rem;
}
`;
// export const ExploreText = styled.div`
//   width: 100%;
//   font-size: 2.1rem;
//   font-family: "Montserrat";
//   text-align: left;
//   // line-height: 1.1;
//   font-weight: 800;
//   color: #ED7D2B;
//   opacity: 1;
//   @media (max-width: 520px) {
//     font-size: 1.3rem;
//   }
// `;

export const ExploreDesc = styled.div`
  width: 100%;
  letter-spacing: 0px;
  color: #4d4d4d;
  opacity: 1;
  font-size: 1rem;
  font-weight: 500;
  margin: 1rem 0rem;
  text-align: center;
  padding-right: 2rem;
  @media (max-width: 520px) {
    font-size: 0.8rem;
  }
  @media (max-width: 475px) {
    padding: 0 0.56rem;
    margin: 0.4rem 0rem;
  }
`;

export const PropertyViewBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ViewBtn = styled.button`
  border-radius: 2px;
  white-space: nowrap;
  padding: 0.8em 8em;
  background: #ed7d2b;
  border: #ed7d2b;
  color: #f1f1f1;
  font-size: 1rem;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  border-radius: 4px;
  margin-top: 1rem;
  font-family: "Montserrat";
  font-weight: 500;
  /* margin-bottom: 1rem; */

  @media screen and (max-width: 480px) {
    padding: 0.7em 6em;
  }
  @media screen and (max-width: 390px) {
    padding: 0.7em 4em;
    font-size: 0.8rem;
  }
`;
